/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BlackListInfo } from './blackListInfo';


export interface DocflowBlackListDialogModel { 
    /**
     * Disputable value with field name
     */
    searchFor: string;
    /**
     * Client id
     */
    clientId: number;
    /**
     * Disputable value
     */
    matches: string;
    /**
     * Workflow method id
     */
    methodId: number;
    /**
     * Document instance id
     */
    instanceId: number;
    /**
     * Comment
     */
    comment?: string | null;
    /**
     * Black list info list
     */
    blackListInfos?: Array<BlackListInfo> | null;
}

